import { Container, TextField } from '@material-ui/core';
import { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  CONTESTATION_FIELDS,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import { get } from 'lodash';
export interface ContestationLawyerOpinionProps {
  intl: IntlShape;
  contestationLawyerOpinion: any;
  updateContestation?: Function | undefined;
  judgementOnMerits: any;
  claimNumber?: string;
  isLawyer?: boolean;
  jmc: any;
  handleSuccessCallback: Function;
  disabled?: boolean;
}

const ContestationLawyerOpinion: FC<ContestationLawyerOpinionProps> = props => {
  const [lawyerOpinion, setLawyerOpinion] = useState<String>(
    get(props, 'contestationLawyerOpinion', ''),
  );

  const validateLawyerOpinion = () => {
    if (props.updateContestation) {
      props.updateContestation(
        props.judgementOnMerits.jom.jmc.id,
        props.judgementOnMerits.jom.jmc.hearingDate,
        lawyerOpinion,
        props.judgementOnMerits.claimId,
        props.judgementOnMerits.procedureType,
        props.judgementOnMerits.judiciaryProcessId,
        props.judgementOnMerits.validator,
        PROCEDURE_STATUSES.PENDING,
        props.claimNumber,
        props.isLawyer,
        true,
        props.handleSuccessCallback,
      );
    }
  };
  return (
    <Container className="subContainer">
      <div className="subContainer">
        <TextField
          fullWidth
          id="contestation_lawyer_opinion_field"
          label={translate(
            messages.judgementOnMeritsLawyerOpinionFieldTitle,
            props,
          )}
          className="input"
          name={CONTESTATION_FIELDS.LAWYER_OPINION}
          onChange={_ => setLawyerOpinion(_.target.value)}
          value={lawyerOpinion}
          style={{ width: '100%' }}
          disabled={
            get(props.jmc, 'status', '') === PROCEDURE_STATUSES.VALIDATED ||
            props.disabled
          }
        />
      </div>
      {!(
        get(props.jmc, 'status', '') === PROCEDURE_STATUSES.VALIDATED ||
        props.disabled
      ) && (
        <div className="subContainer">
          <PrimaryButton
            className="validate-button"
            data-testid="validate"
            background={BUTTON_COLORS.PRIMARY_BLUE}
            border={BUTTON_COLORS.PRIMARY_BLUE}
            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            title={translate(messages.validateButton, props)}
            onClick={validateLawyerOpinion}
            style={{ float: 'right' }}
          />
        </div>
      )}
    </Container>
  );
};

export default injectIntl(ContestationLawyerOpinion);
